import * as React from "react";
const SvgFiRrCream = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cream_svg__a)">
      <path
        fill="#062147"
        d="M22 12.185V11a3 3 0 0 0-2-2.817A14.46 14.46 0 0 0 18.15.81a1.95 1.95 0 0 0-1.717-.818 2.04 2.04 0 0 0-1.664 1.074C14 2.476 13.24 3 11.962 3H10a5.676 5.676 0 0 0-5.939 5.165A3 3 0 0 0 2 11.001v1.184A3 3 0 0 0 0 15v4a5.006 5.006 0 0 0 5 5h14a5.006 5.006 0 0 0 5-5v-4a3 3 0 0 0-2-2.816M10 5h1.962a4.95 4.95 0 0 0 4.566-3.022A12.4 12.4 0 0 1 18 8H6.131A3.66 3.66 0 0 1 10 5m-6 6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1H4zm18 8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cream_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCream;
